import styled from 'styled-components';
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { fonts } from '~/src/helpers/font';
import { styleWithBreakPoints, CSSPropWithBreakpoints, blockMargin } from '~/src/components/LandingBlock/styled';

export interface ITextBlockStyles {
    [key: string]: CSSPropWithBreakpoints;
}

export const Wrapper = styled.div<{ [key: string]: string }>`
    position: relative;
    width: 100%;
    background: ${p => p.background ? `url(${p.background}) no-repeat center / cover` : 'transparent'};

    ${p => blockMargin(p)};     
    ${p => styleWithBreakPoints(p, 'TextBlock')};
`;

export const Grid = styled(GridContainer)`
    max-width: 100%;
`;

export const Text = styled.div`
    font: ${fonts.S};
    color: ${COLORS.black};
    white-space: pre-wrap;

    ${p => styleWithBreakPoints(p, 'TextBlock.Text')};
`;
